import * as React from "react";
const SvgKnot = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("ellipse", { cx: 66, cy: 67, fill: "none", rx: 57, ry: 41, style: {
  fill: "red",
  strokeWidth: 3,
  fillOpacity: 0,
  strokeDasharray: "none",
  stroke: "#060"
}, transform: "matrix(1 0 0 1.19512 -2 -16.073)" }), /* @__PURE__ */ React.createElement("ellipse", { cx: 67, cy: 65, rx: 44, ry: 28, style: {
  fill: "none",
  strokeWidth: 3,
  stroke: "#f03"
}, transform: "matrix(1.0909 0 0 1.39286 -8.09 -26.536)" }));
export default SvgKnot;
